ixModuleRouting("impactx.supplier", {
    "/supplier/:id/:useSetFilter?": {
        templateUrl: "modules/supplier/templates/supplier.html",
        controller: "SupplierDialogCtrl",
        controllerAs: "supplierDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
});
